<script setup lang="ts">
import NotificationMessage from '@/components/common/NotificationMessage.vue';
import LoggedOutFrame from '@/layouts/LoggedOutFrame.vue';
import { PopUpSize } from '@/models/pop-up-size.enum';
import { PopUpType } from '@/models/pop-up-type.enum';
import { NotificationType } from '@onrunning/backstage-models';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { UsersService } from '../services/users.service';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const notification = ref('');
const usersService = new UsersService();
const error = ref<string | undefined>(undefined);
const isLoading = ref(false);

onMounted(() => {
  unsubscribeShipmentEmail();
});

async function unsubscribeShipmentEmail() {
  isLoading.value = true;
  error.value = undefined;

  const token = route.params.token as string;
  const userId = route.params.userId as string;

  try {
    const response = await usersService.unsubscribeEmail(token, userId, NotificationType.PackingSlip);

    if (response.isValid() && response.model) {
      notification.value = t('shipmentEmailUnSubscription.success_message');
    } else {
      error.value = t('shipmentEmailUnSubscription.error_message');
    }
  } catch (e: any) {
    error.value = t(e.message).toString();
  }

  isLoading.value = false;
}

function closePopup() {
  router.replace('/');
}
</script>
<template>
  <LoggedOutFrame
    :header="t('shipmentEmailUnSubscription.header')"
    :background-image-url="t('shipmentEmailUnSubscription.background_image_url')">
    <NotificationMessage
      v-if="notification"
      :size="PopUpSize.Medium"
      :type="PopUpType.Success"
      :title="notification"
      v-on:close="closePopup()">
    </NotificationMessage>
    <NotificationMessage
      v-if="error"
      :size="PopUpSize.Medium"
      :type="PopUpType.Error"
      :title="error"
      v-on:close="closePopup()">
    </NotificationMessage>
  </LoggedOutFrame>
</template>
